import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, isRef as _isRef, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27268f3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title", "onClick"]
const _hoisted_2 = { class: "selector-left" }
const _hoisted_3 = {
  key: 0,
  class: "selector-shortcut"
}
const _hoisted_4 = {
  key: 0,
  class: "with-ctrl"
}
const _hoisted_5 = { class: "selector-right" }
const _hoisted_6 = { class: "selector-value" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "add-option" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = ["disabled"]

import {PropType, ref} from "vue";
import {SelectionGroupOptionData} from "@/lib/components/form/selection/type/SelectionGroupOptionsData";
import {spaceCamelCase} from "@/lib/common/utilities/StringUtilities";


export default /*#__PURE__*/_defineComponent({
  name: 'SelectionGroup',
  props: {
  options: {
    type: Array as PropType<SelectionGroupOptionData[]>,
    required: true,
  },
  selectedOptionsIds: {
    type: Array as PropType<(String|Number)[]>,
    required: true,
  },
  canOptionsBeDeleted: {
    type: Boolean,
    default: false,
  },
  canAddNewOptions: {
    type: Boolean,
    default: false,
  },
  addNewOptionPlaceholder: {
    type: String,
    default: "Option name",
  },
  optionIdHolder: String // if you don't wanna use the array index key as the option id, define a property here
},
  emits: ['select', 'deleteOption', 'addOption'],
  setup(__props, { emit }) {

const props = __props




let newOption = ref("");



const onSelect = (optionId: string|number) =>
{
  emit("select", optionId);
}

const onDeleteOption = (optionId: string|number) =>
{
  emit("deleteOption", optionId);
}

const onAddOption = () =>
{
  const newOptionCopy = newOption.value;

  emit("addOption", newOptionCopy);

  newOption.value = "";
}

const getOptionId = (option: SelectionGroupOptionData, key: number) => {
  return props.optionIdHolder && props.optionIdHolder in option ? option[props.optionIdHolder as keyof typeof option] : key;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (option, id) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "option",
        key: id
      }, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass('selector button-style-bordered ' + (__props.selectedOptionsIds.includes(getOptionId(option, id)) ? ' active' : '')),
          title: option.tooltip ? option.tooltip : '',
          onClick: ($event: any) => (onSelect(getOptionId(option, id)))
        }, [
          _createElementVNode("span", _hoisted_2, [
            _renderSlot(_ctx.$slots, "selectionBody", { option: option }),
            (option.shortcut)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                  (option.shortcut.requiresCtrl)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Ctrl+ "))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_unref(spaceCamelCase)(option.shortcut.keyCode)), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("span", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(option.value), 1)
          ])
        ], 10, _hoisted_1),
        _withDirectives(_createElementVNode("button", {
          type: "button",
          class: "deleter",
          onClick: ($event: any) => (onDeleteOption(getOptionId(option, id)))
        }, "Del", 8, _hoisted_7), [
          [_vShow, __props.canOptionsBeDeleted]
        ]),
        _renderSlot(_ctx.$slots, "additionalOptionActions", { option: option })
      ]))
    }), 128)),
    _withDirectives(_createElementVNode("div", _hoisted_8, [
      _renderSlot(_ctx.$slots, "add-selection"),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "add-option-input",
        placeholder: __props.addNewOptionPlaceholder,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(newOption) ? (newOption).value = $event : newOption = $event))
      }, null, 8, _hoisted_9), [
        [_vModelText, _unref(newOption)]
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "add-option-submit",
        disabled: _unref(newOption) === '',
        onClick: onAddOption
      }, "Add", 8, _hoisted_10)
    ], 512), [
      [_vShow, __props.canAddNewOptions]
    ])
  ]))
}
}

})